import { format } from "date-fns";
export const dateConvert = (date) => {
  if (date) {
    const datetime = new Date(date);

    return format(datetime, "do MMMM yyyy HH:mm EEEE");
  }
};

export const GMTDateConvert = (value) => {
  const date = new Date(value);

  const year = date.getUTCFullYear();
  const month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
  const day = ('0' + date.getUTCDate()).slice(-2);
  const hours = ('0' + date.getUTCHours()).slice(-2);
  const minutes = ('0' + date.getUTCMinutes()).slice(-2);
  const seconds = ('0' + date.getUTCSeconds()).slice(-2);
  const milliseconds = ('00' + date.getUTCMilliseconds()).slice(-3);

  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + '.' + milliseconds + 'Z';
}